/* eslint-disable no-unused-vars */
/* global G, PLATFORM */
import { settings } from 'app/_shared/session'
import sequenceComponentState from 'lib/sequence/component/state'
import { isObj } from 'lib/util'

const {
  get: getFieldsConfig,
  set: setFieldsConfig,
} = sequenceComponentState('fields')

const {
  get: getConfiguration,
  set: setConfiguration,
} = sequenceComponentState('configuration')

const { serialFieldConfig } = settings

/**
 * If the serialFieldConfig setting is set, initializes the serial field component with it.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const initTextFieldGroup = module => async (components, ...args) => {
  const { serial } = components

  if (serialFieldConfig && !getFieldsConfig(serial)) {
    const config = serialFieldConfig?.map(item => ({
      ...item,
      label: item.label ? module[G.ADAPTER][G.INTL]._t(
        `serialField.${item.key}.label`,
        {
          ns: 'custom',
          _key: `serialField.${item.key}.label`,
          defaultValue: item.label,
        },
      ) : '',
      placeholder: item.placeholder ? module[G.ADAPTER][G.INTL]._t(
        `serialField.${item.key}.placeholder`,
        {
          ns: 'custom',
          _key: `serialField.${item.key}.placeholder`,
          defaultValue: item.placeholder,
        },
      ) : '',
      helperText: item.helperText ? module[G.ADAPTER][G.INTL]._t(
        `serialField.${item.key}.helperText`,
        {
          ns: 'custom',
          _key: `serialField.${item.key}.helperText`,
          defaultValue: item.helperText,
        },
      ) : '',
    }))

    setFieldsConfig(serial, config)
  }

  return [components, ...args]
}

/**
 * Passes the `serialFieldConfig` object from {@link settings} to the serial component, giving
 * priority to the existing (configuration) props.
 *
 * @param {Gaia.AppModule.Spec} module
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const initMaskField = module => async (components, ...args) => {
  const { serial } = components

  if (serialFieldConfig && !getFieldsConfig(serial)) {
    const configuration = getConfiguration(serial)
    const newConfiguration = { ...serialFieldConfig, ...configuration }
    setConfiguration(serial, newConfiguration)
  }

  return [components, ...args]
}

/**
 * Returns {@link initMaskField} or {@link initTextFieldGroup} depending on whether the
 * `serialFieldConfig` setting is set and is an object.
 */
const initSerialField = PLATFORM === 'web' && (!serialFieldConfig || isObj(serialFieldConfig))
  ? initMaskField
  : initTextFieldGroup

export default initSerialField
